import { render, staticRenderFns } from "./AddNewsModal.vue?vue&type=template&id=de7e0bc8&"
import script from "./AddNewsModal.vue?vue&type=script&lang=ts&"
export * from "./AddNewsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports